module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Wuerenlingen_AG-fedcd85e1433a997463bf8ea64b6ae8a.svg";